export default {
	headers: {
		financialFiles: 'Expediente financiero',
		user: 'Usuaria',
		actions: 'Cambiar',
		changeType: 'Tipo de cambio',
		date: 'Fecha',
		description: 'Descripción'
	},
	label: {
		logType: 'Tipo de registro',
		user: 'Usuario',
		fromDate: 'Desde la fecha',
		toDate: 'Hasta la fecha'
	},

	accounts: 'Cuentas',
	accounting: 'Contabilidad',
	currencies: 'Monedas',
	'financial-file': 'Expediente financiero',
	'fund-flow': 'Flujo de fondos',
	manufacturing: 'Fabricación',
	'material-flow': 'Flujo de materiales',
	'material-warehouse': 'Almacén de materiales',
	users: 'Usuarios',


	fetch: 'Lectura',
	create: 'Actualizar',
	update: 'Crear',
	delete: 'Borrar',

	search: 'Buscar'
}